var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-shopping-cart';
                    var viewUrl = 'gfx/sprite.svg#view-icon-shopping-cart';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };